import { css } from 'styled-components';

import COLOR from '../../../utils/colors.constants';

const Erro = css`
  * {
    border-color: ${COLOR.VERMELHO} !important;
    color: ${COLOR.VERMELHO} !important;
  }

  
`;

export default Erro;
